import React from "react";

import TeamTable from "components/teamTable";

const TeamScreen = () => {
  return <TeamTable />;
};

export default TeamScreen;
